import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {Product} from '../models/product';

export const billingLicencesActionTypes = {
  LOAD: type('[BillingLicences] Load'),
  LOAD_SUCCESS: type('[BillingLicences] Load Success'),
  LOAD_FAIL: type('[BillingLicences] Load Error')
};

export class LoadBillingLicencesAction implements Action {
  readonly type = billingLicencesActionTypes.LOAD;
  constructor() {}
}

export class LoadBillingLicencesSuccessAction implements Action {
  readonly type = billingLicencesActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Product[]) {}
}

export class LoadBillingLicencesFailAction implements Action {
  readonly type = billingLicencesActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
